/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import Button from 'newComponents/Button';
import { useSelector } from 'react-redux';
import { getApaMetadataLite } from 'services/api/apa/metadata';
import { converter } from 'helpers/converter';
import HtmlParser from 'components/HtmlParser';

import 'containers/Register/components/TermsAndConditions/styles.scss';

const selectTranslations = store => store.translations;

const TermsAndConditions = ({
  onReturnClick,
  onAnchorClick,
  apaKey = 'tyc_full_text',
}) => {
  const divRef = useRef(null);
  const translationsInStore = useSelector(selectTranslations);
  const [translations, setTranslations] = useState(null);
  const backButtonKey = translationsInStore.btn_menu_back;

  const getDisclaimerData = () =>
    converter.convertApaUnicode(translations, apaKey, '');

  const getTranslations = async () => {
    const metadataTranslations = await getApaMetadataLite();
    setTranslations(metadataTranslations);
  };

  const scrollToTop = () => {
    divRef.current.scrollTo({ top: 0, behavior: 'instant' });
  };

  const handleAnchorClick = href => {
    scrollToTop();
    onAnchorClick(href);
  };

  const handleReturn = () => {
    scrollToTop();
    onReturnClick();
  };

  useEffect(() => {
    getTranslations();
  }, []);

  return (
    <div className="TermsAndConditions">
      <div className="TermsAndConditions__Container">
        <div className="TermsAndConditions__Text" ref={divRef}>
          <div>
            <HtmlParser onAnchorClick={handleAnchorClick}>
              {getDisclaimerData()}
            </HtmlParser>
          </div>
        </div>

        <div className="TermsAndConditions__Blur" />

        <div className="TermsAndConditions__Button_Container">
          <Button color="red" onClick={handleReturn}>
            <span style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
              {backButtonKey}
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
